import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useBuscaProdutos from '../../services/Produto/BuscaProduto';
import useBuscaClientes from '../../services/Cliente/useBuscaClientes';
import secureStorage from '../../utils/SecureStorage';
import ProdutoDel from '../../services/Produto/ProdutoDel';
import * as S from './styles';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import ModalCadastroProduto from "../../components/ModalCadastroProduto";
import { MdArrowBack } from 'react-icons/md';

const ProdutoLista = () => {
  const [filtro, setFiltro] = useState('');
  const [clienteSelecionado, setClienteSelecionado] = useState('');
  const [produtosSelecionados, setProdutosSelecionados] = useState([]);
  const [agruparPorCliente, setAgruparPorCliente] = useState(false);
  const { searchResultsprodutos, loadprodutos } = useBuscaProdutos([]);
  const { searchResults: clientes, loadregistros } = useBuscaClientes([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [produtoEditando, setProdutoEditando] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const idrede = secureStorage.getItem("id_r");
    if (idrede) {
      loadprodutos(idrede);
      loadregistros(idrede);
    }
  }, []);

  const toggleSelecionado = (id) => {
    setProdutosSelecionados((prev) =>
      prev.includes(id) ? prev.filter((pid) => pid !== id) : [...prev, id]
    );
  };

  const deletarSelecionados = async () => {
    for (const id of produtosSelecionados) {
      try {
        await ProdutoDel.excluirProduto(id);
      } catch (error) {
        console.error('Erro ao excluir produto:', error);
      }
    }
    const idrede = secureStorage.getItem("id_r");
    loadprodutos(idrede);
    setProdutosSelecionados([]);
  };

  const produtosFiltrados = searchResultsprodutos.filter((p) => {
    const descricaoMatch = p.description?.toLowerCase().includes(filtro.toLowerCase());
    const clienteMatch = clienteSelecionado ? p.id_Cliente?.[0] === clienteSelecionado : true;
    return descricaoMatch && clienteMatch;
  });

  const produtosSemCliente = produtosFiltrados.filter(
    (p) => !p.id_Cliente || p.id_Cliente.length === 0 || !p.id_Cliente[0]
  );

  const produtosComClienteAgrupados = clientes.reduce((acc, cliente) => {
    const produtosDoCliente = produtosFiltrados.filter(
      (p) => p.id_Cliente?.[0] === cliente._id?.$oid
    );
    if (produtosDoCliente.length > 0) {
      acc.push({ cliente: cliente.nome, produtos: produtosDoCliente });
    }
    return acc;
  }, []);

  const produtosAgrupados = agruparPorCliente
    ? [
        { cliente: 'Sem Cliente', produtos: produtosSemCliente },
        ...produtosComClienteAgrupados
      ]
    : [{ cliente: null, produtos: produtosFiltrados }];

  const abrirModalNovo = () => {
    setProdutoEditando(null);
    setModalAberto(true);
  };

  const abrirModalEditar = (produto) => {
    setProdutoEditando(produto);
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setProdutoEditando(null);
  };

  return (
    <>
      <Header />
      <S.BackButton onClick={() => navigate('/home')}>
                      <MdArrowBack style={{ marginRight: '8px', fontSize: '20px' }} />
                      Voltar
                  </S.BackButton>
      <S.Container style={{ paddingBottom: '100px' }}>
        <div style={{ textAlign: 'center', margin: '40px 0 24px' }}>
          <S.Title>Cadastro de Produtos</S.Title>
        </div>

        <S.TopActions>
          <button onClick={() => setAgruparPorCliente(!agruparPorCliente)}>
            {agruparPorCliente ? 'Desagrupar' : 'Agrupar por Cliente'}
          </button>
          <button onClick={abrirModalNovo}>Cadastrar Novo</button>
          <button onClick={deletarSelecionados} disabled={produtosSelecionados.length === 0}>
            Deletar Selecionados
          </button>
        </S.TopActions>

        <S.ActionInputWrapper>
          <input
            type="text"
            placeholder="Buscar por nome..."
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
          />

          <select
            value={clienteSelecionado}
            onChange={(e) => setClienteSelecionado(e.target.value)}
            style={{ marginLeft: '10px' }}
          >
            <option value="">Todos os Clientes</option>
            {clientes.map((cliente) => (
              <option key={cliente._id.$oid} value={cliente._id.$oid}>
                {cliente.nome}
              </option>
            ))}
          </select>
        </S.ActionInputWrapper>

        {produtosAgrupados.length > 0 ? (
          <S.ScrollableTableArea>
            {produtosAgrupados.map(({ cliente, produtos }) => (
              <div key={cliente || 'todos'} style={{ marginBottom: '30px' }}>
                {cliente && <h3 style={{ margin: '20px 0 10px' }}>{cliente}</h3>}
                <S.StyledTable>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Cliente</th>
                      <th>Descrição</th>
                      <th>GTIN</th>
                      <th>Preço</th>
                      <th>Marca</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {produtos.map((prod) => {
                      const clienteObj = clientes.find((c) => c._id?.$oid === prod.id_Cliente?.[0]);
                      return (
                        <tr key={prod._id?.$oid || prod.gtin}>
                          <td>
                            <input
                              type="checkbox"
                              checked={produtosSelecionados.includes(prod._id?.$oid)}
                              onChange={() => toggleSelecionado(prod._id?.$oid)}
                            />
                          </td>
                          <td>{clienteObj?.nome || '---'}</td>
                          <td>{prod.description}</td>
                          <td>{prod.gtin}</td>
                          <td>{prod.price}</td>
                          <td>{prod.brand?.name || '---'}</td>
                          <td>
                            <S.EditButton onClick={() => abrirModalEditar(prod)}>
                              Editar
                            </S.EditButton>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </S.StyledTable>
              </div>
            ))}
          </S.ScrollableTableArea>
        ) : (
          <p style={{ textAlign: 'center', marginTop: '20px' }}>Nenhum produto encontrado.</p>
        )}
      </S.Container>

      <ModalCadastroProduto
        isOpen={modalAberto}
        onClose={fecharModal}
        produto={produtoEditando}
        atualizarLista={() => loadprodutos(secureStorage.getItem("id_r"))}
      />
      <Footer />
    </>
  );
};

export default ProdutoLista;